<template>
  <b-form @submit.prevent="submitSignIn" novalidate>
    <div v-if="lastDash== '-LoyagU1QYSXEDcp9VIZ'">
      <h3>Welcome to the UF Green Job Platform.</h3>
      <p>
        We connect UF students and graduates to organizations and professionals in the Real Estate, Design and Construction Industries.
        <br />Go Gators.
      </p>
    </div>

    <b-form-group label="E-mail:" label-for="signInEmailInput">
      <b-form-input
        id="signInEmailInput"
        type="email"
        required
        placeholder="example@domain.com"
        autocomplete="on"
        v-model.trim="$v.email.$model"
        :class="{ 'is-invalid': $v.email.$error }"
        :disabled="authInProgress"
      ></b-form-input>
      <b-form-invalid-feedback v-if="!$v.email.required">E-mail field is required</b-form-invalid-feedback>
      <b-form-invalid-feedback
        v-if="!$v.email.eamil && $v.email.required"
      >E-mail field must contain valid E-mail address</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Password:" label-for="signInPasswordInput">
      <b-form-input
        id="signInPasswordInput"
        type="password"
        required
        autocomplete="on"
        v-model.trim="$v.password.$model"
        :class="{ 'is-invalid': $v.password.$error }"
        :disabled="authInProgress"
      ></b-form-input>
      <b-form-invalid-feedback v-if="!$v.password.required">Password field is required</b-form-invalid-feedback>
      <b-form-invalid-feedback
        v-if="!$v.password.minLength && $v.password.required"
      >Password must have at least {{$v.password.$params.minLength.min}} letters</b-form-invalid-feedback>

      <!-- RESET PASS -->
      <p
        class="text-muted text-center h5 mb-0"
        style="cursor:pointer"
        @click="resetPass"
      >Reset your password</p>
      <p
        class="text-center text-small"
        :class="{'text-success':resetPassRes.status=='success', 'text-warning':resetPassRes.status=='fail'}"
        v-if="resetPassRes.message"
      >
        <small>{{resetPassRes.message}}</small>
      </p>
      <!-- /RESET PASS -->
    </b-form-group>

    <div>
      <b-button
        variant="info"
        class="authForm__submit"
        type="submit"
        :disabled="authInProgress"
      >Submit</b-button>
    </div>
  </b-form>
</template>

<script>
import config from '@/config'
import axios from 'axios'
// modules
import { mapState } from 'vuex'
import { required, minLength, email } from 'vuelidate/lib/validators'
// services
import auth from '@/services/auth'
import db from '@/services/db'
// helpers
import utils from '@/helpers/utils/index.js'

export default {
  data() {
    return {
      email: '',
      password: '',
      resetPassRes: {},
      lastDash: null,
    }
  },
  computed: {
    ...mapState(['authInProgress', 'userId']),
  },
  mounted() {
    this.lastDash = localStorage.getItem('lastDash')
  },
  methods: {
    submitSignIn() {
      if (this.authInProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.$store.commit('addProcess', {
        process: 'signIn',
        message: 'Sign in',
      })
      this.$store.commit('destroyCasl')
      auth.signIn(this.email, this.password, async err => {
        this.$store.commit('deleteProcess', 'signIn')
        if (err) {
          this.$store.commit('addError', err.message)
        } else {
          await utils.checkDomainAssignment(this)
        }
      })
    },
    oAuthSignIn(provider) {
      switch (provider) {
        case 'google':
          auth.signInWithGoogle(async () => {
            await utils.checkDomainAssignment(this)
          })
          break
      }
    },
    resetPass() {
      const message = 'Are you sure to reset your password?'

      if (!confirm(message)) return

      const functionsUrl = config.midServer[process.env.APP_CONF.instance]
      const functionLink = `${functionsUrl}/resetPasswordByEmail`
      const vm = this
      const lastDash = localStorage.getItem('lastDash')

      axios
        .post(
          functionLink,
          JSON.stringify({
            email: encodeURIComponent(vm.email),
            lastDash,
          })
        )
        .then(res => {
          // console.log(res);
          this.resetPassRes = res.data
          setTimeout(() => {
            this.resetPassRes = {}
          }, 4000)
        })
        .catch(err => console.log('errr'))
    },
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(6),
    },
  },
}
</script>
